module.exports = __webpack_public_path__ + "img/microsoft_window.83dc56fc.svg";